<template>
  <fragment>
    <search-nav-start-end label="작성일" v-model="nav.created_at"/>
    <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="searchTypes"/>
    <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.searchKeyword"/>
  </fragment>
</template>

<script>
import SearchNavStartEnd from '@/components/nav/SearchNavStartEnd.vue'
import SearchNav from '@/components/nav/SearchNav'
import SearchNavItemKeyword from '@/components/nav/SearchNavItemKeyword'
import SearchNavItemSelect from '@/components/nav/SearchNavItemSelect'

export default {
  name: 'NormalSearchNav261',
  components: {
    SearchNavStartEnd,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNav,
  },
  watch: {
    nav: {
      immediate: true,
      deep: true,
      handler () {
        this.$emit('input', this.nav)
      }
    }
  },
  data () {
    return {
      nav: {
        created_at: '',

        searchType: '',
        searchKeyword: '',
      },
      searchTypes: [
        {
          text: '회사명',
          value: '회사명'
        },
        {
          text: '공사일보 작성일',
          value: '공사일보 작성일'
        },
        {
          text: '인원투입 현황(원도급)',
          value: '인원투입 현황(원도급)'
        },
        {
          text: '주요장비 반입현황(원도급)',
          value: '주요장비 반입현황(원도급)'
        },
        {
          text: '인원투입 현황(하도급업체)',
          value: '인원투입 현황(하도급업체)'
        },
        {
          text: '주요장비 반입현황(하도급업체)',
          value: '주요장비 반입현황(하도급업체)'
        },
      ],
    }
  }
}
</script>

<style scoped>

</style>
